import * as React from 'react'
import { useShowContext, SimpleShowLayout, Show, useTranslate } from 'react-admin'
import { Grid, Container } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { ShowListElement } from 'src/components/uiElements/CRUD/ShowListElement'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'

const ShowWrapper = ({ children }) => <Container maxWidth='false'> {children}</Container>

const ShowContent = () => {
  const translate = useTranslate()
  const {
    error, // error returned by dataProvider when it failed to fetch the record. Useful if you want to adapt the view instead of just showing a notification using the `onError` side effect.
    isLoading, // boolean that is true until the record is available for the first time
    record, // record fetched via dataProvider.getOne() based on the id from the location
  } = useShowContext()

  if (isLoading) {
    return <div>{translate('ra.action.loading')}</div>
  }
  if (error) {
    return <div>{translate('ra.notification.http_error')}</div>
  }

  return (
    <SimpleShowLayout>
      <CardCommon
        title={translate('ra.entity.formula-global-variables')}
        actions={<CardCrudBottomButtons btnEdit={true} />}
      >
        <Grid container spacing={3}>
          <ShowListElement label={translate('ra.field.id')} value={record.id} />
          <ShowListElement label={translate('ra.field.name')} value={record.name} />
          <ShowListElement label={translate('ra.field.value')} value={record.value} />
          <ShowListElement label={translate('ra.field.show')} value={record.show} boolean />
        </Grid>
      </CardCommon>
    </SimpleShowLayout>
  )
}

export const FormulaGlobalVariablesShow = (props) => {
  return (
    <Show component={ShowWrapper} {...props} actions={null} className='CrudShowContainer'>
      <ShowContent {...props} />
    </Show>
  )
}
